import { render, staticRenderFns } from "./TrafficChart.vue?vue&type=template&id=08580a18&"
import script from "./TrafficChart.vue?vue&type=script&lang=js&"
export * from "./TrafficChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports